var React = require('react');

function IcArrowNext (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.165039 18.1301L1.93504 19.9001L11.835 10.0001L1.93504 0.100098L0.165039 1.8701L8.29504 10.0001L0.165039 18.1301H0.165039Z","fill":"currentColor"}));
}

IcArrowNext.defaultProps = {"width":"12","height":"20","viewBox":"0 0 12 20"};

module.exports = IcArrowNext;

IcArrowNext.default = IcArrowNext;
